<!-- @if(processDone){
<label *ngIf="mail?.linkBy && !mailboxReadonly" class="float-end">
	Linked By: {{mail?.linkBy}}
</label>
<label *ngIf="mail?.unlinkBy && !mailboxReadonly" class="float-end">
	Unlinked By: {{mail?.unlinkBy}}
</label>
<h3>
	<strong>{{mail?.subject}}</strong>
</h3>
<div class="clearfix">
	<p class="float-start m-0">
		<span class="text-muted me-1">From:</span>
		<a (click)="openCopyModalTrailMail()" *ngIf="mail?.from_name" style="cursor: pointer;"
			matTooltip="{{mail?.from_email}}">{{mail?.from_name}}<span></span></a>
		<a (click)="openCopyModalTrailMail()" *ngIf="!mail?.from_name" style="cursor: pointer;"
			matTooltip="{{mail?.from_email}}">{{mail?.from_email}}<span></span></a>
	</p>
	<p class="float-end m-0">
		<span>{{mail?.messageDate}}</span>
	</p>
	<br>
	<p class="float-start m-0">
		<span class="text-muted me-1 ms-1">To:</span>
		<span *ngFor="let data of mail?.toMailArr">{{data.value}};</span>
	</p>
	<br>
	<p class="float-start m-0" *ngIf="mail?.ccArr?.length">
		<span class="text-muted me-1 ms-1">Cc:</span>
		<span [ngStyle]="{'padding-left': isFirst ? '' : '40px'}"
			*ngFor="let data of mail?.ccArr; first as isFirst">{{data.value}}; <span *ngIf="!isFirst">
				<br> </span> </span>
	</p>
</div>
<ng-container *ngIf="mail?.attachmentsArr!=null && mail?.attachmentsArr.length">
	<hr />
	<p class="text-muted">Attachments</p>
	<view-attachments [attachmentsArr]="mail?.attachmentsArr"></view-attachments>
</ng-container>
<hr />
<app-mail-content [viewMail]="mail" (mail_html_fetched)="mail_html_fetched_here($event)">
</app-mail-content>
} -->

<div class="card mb-2" [hidden]="hideMain">
	<div class="card-body">
		<p class="text-end mb-0 small fw-bold">
			@if (mail?.linkBy && !mailboxReadonly) {
			<span class="ms-2">
				Linked By: {{mail?.linkBy}}
			</span>
			}
			@if (mail?.unlinkBy && !mailboxReadonly) {
			<span class="ms-2">
				Unlinked By: {{mail?.unlinkBy}}
			</span>
			}
		</p>
		<h3>
			<strong>{{mail?.subject}}</strong>
		</h3>
		<div class="row">
			<div class="col">
				<span class="text-muted">From:</span>
				@if(mail?.from_name){
				<a (click)="openCopyModalTrailMail()" style="cursor: pointer;" matTooltip="{{mail?.from_email}}">
					{{mail?.from_name}}
				</a>
				}@else {
				<a (click)="openCopyModalTrailMail()" style="cursor: pointer;" matTooltip="{{mail?.from_email}}">
					{{mail?.from_email}}
				</a>
				}
			</div>
			<div class="col text-end">
				<strong class="small">
					{{mail?.messageDate}}
				</strong>
			</div>
		</div>
		<div class="row">
			<div class="col">
				<span class="text-muted">To:</span>
				@for (data of mail?.toMailArr; track $index) {
				<span>
					{{data.value}};
				</span>
				}
			</div>
		</div>
		@if(mail?.ccArr && mail?.ccArr?.length){
		<div class="row">
			<div class="col">
				<span class="text-muted">CC:</span>
				@for (data of mail?.ccArr; track $index) {
				<span>
					{{data.value}};
				</span>
				}
			</div>
		</div>
		}
		@if(mail?.bccArr && mail?.bccArr?.length){
		<div class="row">
			<div class="col">
				<span class="text-muted">BCC:</span>
				@for (data of mail?.bccArr; track $index) {
				<span>
					{{data}};
				</span>
				}
			</div>
		</div>
		}
		<div class="row">
			<div class="col">
				@if (mail?.category!='draft' && mail?.attachmentsArr!=null && mail?.attachmentsArr.length) {
				<hr />
				<p class="text-muted">Attachments</p>
				<view-attachments [attachmentsArr]="mail?.attachmentsArr">
				</view-attachments>
				}
				<hr />
				@if(fetchingHtml){
				<div class="row">
					<div class="col-md-12">
						<div class="text-center">
							<img src="../../../assets/img/loading.gif" class="w-100px" />
						</div>
					</div>
				</div>
				}
				<iframe #iframe frameborder="0" scrolling="yes" (load)="resizeIframe(iframe)" [ngStyle]="style">
				</iframe>
			</div>
		</div>
	</div>
</div>